import React from 'react'
import { getWidgetTypeLabel } from '../../constants/widgetTypes'
import { widgetTypeColorClass } from './widgetTypeColors'
import styles from './widgetTypeColors.module.scss'

interface WidgetTypeBadgeProps {
  code: string
  className?: string
}

/**
 * The widget-type badge: a widget type's short label in that type's color. Used
 * wherever a widget is listed with its type — the placements list, the
 * placement detail drawer and the widget library.
 */
const WidgetTypeBadge: React.FC<WidgetTypeBadgeProps> = ({ code, className = '' }) => (
  <span className={`${styles.badge} ${widgetTypeColorClass(code)} ${className}`}>
    {getWidgetTypeLabel(code)}
  </span>
)

export default WidgetTypeBadge
